const ptBrTranslations = {
  translations: {
    pageTitle: "Housien Autenticação",

    help: {
      nextButton: "Próximo",
      backButton: "Voltar",
      defaultSelect: "Selecione uma opção...",
      showPasswordCheck: "Mostrar senha",
      timeForNewCodeText: "Receber novo código",
      timeForNewCodeLink: "Enviar novo código",
      check: "Marque a caixa de seleção para continuar.",
      fieldOrSelect: "O campo {{placeholder}} é obrigatório.",
      toggleTheme: "Alternar tema",
      toggleThemeToDark: "Alternar para modo escuro",
      toggleThemeToLight: "Alternar para modo claro",
      requiredField: "Campo obrigatório",
      noOptionsFound: "Nenhuma opção encontrada.",
      noCountriesFound: "Nenhum país encontrado.",
      timeForNewCodeCountdown: "({{seconds}} segundos)",
      recaptchaWaiting: "Aguarde a verificação de segurança ser concluída...",
      clientLogoAlt: "Logo do cliente",
      k4dLogoAlt: "Logo K4D",
      housienLogoAlt: "Logo Housien",
      closeAriaLabel: "Fechar",
      and: "e",
    },

    error: {
      pageTitle: "Erro",
      oauth: {
        title: "Ops! Algo deu errado",
        message: "Não conseguimos processar sua solicitação. Verifique se o link de acesso está correto e tente novamente.",
        cta: "Tentar novamente",
        missing: "Parâmetros obrigatórios ausentes: {{params}}",
        invalid: "Os parâmetros fornecidos são inválidos ou incompletos.",
        clientInvalid: "O client_id fornecido não é válido ou não está registrado no sistema.",
        providerError: "Código de erro: {{code}}\nMensagem: {{message}}",
        unexpected: "Erro inesperado."
      },
      recaptcha: {
        details: "Nosso serviço anti-bot não está respondendo corretamente. Por favor, tente novamente mais tarde.",
        tokenRequired: "Token anti-bot é necessário para a solicitação de autenticação. Por favor, certifique-se de que o reCAPTCHA foi executado antes de fazer esta solicitação.",
        tokenNotAvailable: "Token anti-bot é necessário mas não está disponível. Por favor, certifique-se de que o reCAPTCHA foi executado.",
        notReady: "reCAPTCHA não está pronto. Por favor, aguarde a inicialização ser concluída.",
        userFacing: "Verificação de segurança falhou. Aguarde alguns segundos e tente novamente.",
        retry: "Tentar novamente"
      },
      antiBot: {
        InvalidTokenError: "A validação de segurança falhou. Por favor, atualize a página e tente novamente.",
        MissingTokenError: "A verificação de segurança não foi concluída. Por favor, atualize a página e tente novamente."
      },
      social: {
        title: "Login Social Indisponível",
        message: "Sua conta social não possui um endereço de e-mail verificado, que é necessário para entrar.",
        details: "Para continuar, adicione e verifique um endereço de e-mail no seu provedor social (Google, Facebook, etc.) e tente entrar novamente.",
        cta: "Voltar ao login"
      },
      route: {
        title: "Página não encontrada",
        message: "A página que você está procurando não existe ou foi movida. Verifique o endereço e tente novamente.",
        path: "Rota solicitada: {{path}}",
        cta: "Voltar"
      },
      timeout: {
        title: "Tempo de espera esgotado",
        message: "O servidor não está respondendo. Por favor, aguarde alguns instantes e tente novamente.",
        details: "O tempo limite de 1 minuto foi excedido enquanto aguardávamos uma resposta do servidor.",
        cta: "Tentar novamente"
      },
      general: {
        title: "Algo deu errado",
        message: "Ocorreu um erro inesperado. Tente novamente em alguns instantes.",
        missing: "Argumentos obrigatórios: {{params}}",
        altText: "Ilustração de erro",
        cta: "Voltar"
      },
      clientNotFound: {
        title: "Cliente não encontrado",
        message: "O Client ID {{clientId}} não está registrado.",
        networkError: "Erro de rede, verifique sua conexão."
      },
      help: "Lamentamos o inconveniente. Se o problema persistir, entre em contato com o suporte.",
      details: {
        show: "Ver detalhes técnicos",
        hide: "Ocultar detalhes técnicos"
      },
      token: {
        expired: "O token de autenticação expirou. Por favor, atualize a página.",
        expiringSoon: "O token expira em {{timeString}}. Por favor, conclua sua ação em breve."
      },
      recoveryPassword: {
        missingToken: "Token de recuperação ausente. Por favor, use um link de recuperação válido.",
        invalidLinkTitle: "Link de Recuperação Inválido"
      },
      runtime: {
        redirectFailed: "Falha ao redirecionar após autenticação. Tente novamente.",
        unexpectedPasswordResponse: "Tipo de resposta inesperado da autenticação por senha. Tente novamente.",
        unexpectedSecondFactorResponse: "Tipo de resposta inesperado da autenticação de segundo fator. Tente novamente.",
        requestTimeout: "A solicitação expirou. Tente novamente.",
        networkError: "Erro de rede - verifique sua conexão e tente novamente.",
        maxRecoverySends: "Máximo de envios de links de recuperação atingido. Entre em contato com os administradores do sistema.",
        recoveryCooldown: "Aguarde {{seconds}} segundos antes de enviar outro link de recuperação de senha.",
        requestInProgress: "Solicitação em andamento.",
        noIdentityToken: "Nenhum token de identidade válido encontrado. Complete a etapa de identidade primeiro.",
        oauth2Required: "As informações do cliente OAuth2 são obrigatórias. Certifique-se de que os parâmetros OAuth2 sejam fornecidos.",
        missingRecoveryParams: "Parâmetros de recuperação obrigatórios ausentes. Use um link de recuperação válido.",
        invalidAuthToken: "Token de autenticação inválido ou expirado.",
        recaptchaUnavailable: "reCAPTCHA não está disponível.",
        recaptchaFailed: "Falha ao obter o token anti-bot do reCAPTCHA.",
        recaptchaNotReadyTimeout: "reCAPTCHA não foi ativado dentro do tempo limite. Atualize a página.",
        noIdentityResponse: "Nenhuma resposta de identidade encontrada.",
        noPersonalInfoResponse: "Nenhuma resposta de informações pessoais encontrada.",
        noPasswordResponse: "Nenhuma resposta de senha encontrada.",
        requestCancelled: "A solicitação foi cancelada.",
        antiBotRequired: "O token anti-bot é necessário para a solicitação de autenticação.",
      }
    },

    login: {
      identity: {
        pageTitle: "Entrar",
        title: "Entrar",
        subtitle: "Use sua conta para acessar nossos serviços.",
        subtitleTemplate: "Use sua conta {{clientName}} para acessar nossos serviços.",
        emailPlaceholder: "E-mail",
        emailPlaceholderHint: "seu@email.com",
        forgotEmailLink: "Esqueceu seu e-mail?",
        guestModeText:
          "Não é seu computador? Use o modo visitante para conectar de maneira privada.",
        guestModeLink: "Mais detalhes, por favor!",
        createAccountButton: "Criar conta",
        nextButton: "Próximo",
        orConnectWithText: "ou",
        continueWithGoogle: "Continuar com Google",
        continueWithFacebook: "Continuar com Facebook",
        continueWithApple: "Continuar com a Apple",
        googleUnavailable: "A autenticação com Google está temporariamente indisponível. Por favor, tente novamente mais tarde ou use outro método de login.",
        facebookUnavailable: "A autenticação com Facebook está temporariamente indisponível. Por favor, tente novamente mais tarde ou use outro método de login.",
        appleUnavailable: "A autenticação com a Apple está temporariamente indisponível. Por favor, tente novamente mais tarde ou use outro método de login.",
        recaptchaNotice: "Protegido por reCAPTCHA. Política de Privacidade e Termos de Serviço do Google se aplicam.",
      },

      password: {
        pageTitle: "Senha",
        title: "Olá, {{username}}",
        subtitle: "Confirme sua identidade",
        passwordPlaceholder: "Senha",
        forgotPasswordLink: "Esqueceu sua senha?",
        securityWarning: "Nunca compartilhe sua senha com terceiros. O Housien nunca solicita sua senha por telefone, email ou WhatsApp.",
        securityWarningLink: "Saiba mais sobre segurança.",
      },

      sendRecoveryPasswordLink: {
        pageTitle: "Recuperar Senha",
        title: "Esqueceu sua senha?",
        subtitle: "Crie uma nova senha seguindo as orientações",
        text: "Enviamos um link para o email {{email}}, acesse este link para criar uma nova senha.",
        initialText: "Clique no botão abaixo para enviar um link de recuperação de senha para seu email {{email}}.",
        timeLabel: "Receber novo link",
        linkLabel: "Enviar novo link",
        buttonText: "Enviar link de recuperação",
        buttonWaitText: "Aguarde {{seconds}} segundos",
        buttonSendingText: "Enviando...",
        buttonMaxReachedText: "Máximo de envios atingido",
        cooldownMessage: "Você pode enviar outro link de recuperação em {{seconds}} segundos.",
        sendCountMessage: "Links de recuperação enviados: {{count}}/3",
        maxSendsMessage: "Impossível enviar um novo link de recuperação. Entre em contato com os administradores do sistema.",
        recoveryLinkSentTitle: "Link de Recuperação Enviado"
      },

      recoveryPassword: {
        pageTitle: "Nova Senha",
        title: "Criar nova senha",
        subtitle: "Insira e confirme uma nova senha para acessar sua conta"
      },

      secondFactor: {
        pageTitle: "Autenticação em Dois Fatores",
        title: "Verificação de Dois Fatores",
        subtitle: "Digite o código de verificação enviado para o seu email",
        codePlaceholder: "Inserir código"
      },
    },

    signup: {
      createAccount: {
        pageTitle: "Criar Conta",
        title: "Criar uma Conta Housien",
        subtitle: "Insira seu Nome e sua Nacionalidade",
        namePlaceholder: "Nome",
        surnamePlaceholder: "Sobrenome (opcional)",
        nationalityPlaceholder: "De onde você é?",
        serviceTermsCheck: "Concordo com os",
        serviceTermsLink: "Termos de Serviço",
        privacyPolicyLink: "Políticas de Privacidade",
        loginButton: "Já possui conta?",
      },

      birthdayGender: {
        pageTitle: "Informações Pessoais",
        title: "Informações básicas",
        subtitle: "Digite sua data de nascimento e gênero",
        dayPlaceholder: "Dia",
        monthPlaceholderSelect: "Mês",
        monthPlaceholderSelectOptions:
          "Janeiro,Fevereiro,Março,Abril,Maio,Junho,Julho,Agosto,Setembro,Outubro,Novembro,Dezembro",
        yearPlaceholder: "Ano",
        genderPlaceholderSelect: "Gênero",
        genderPlaceholderSelectOptions:
          "Feminino,Masculino,Personalizar,Prefiro não dizer",
        genderPlaceholder: "Qual é o seu gênero",
        pronounPlaceholderSelect: "Refira-se a mim como",
        pronounPlaceholderSelectOptions: "Feminino,Masculino,Outro",
      },

      insertUsername: {
        pageTitle: "Escolher E-mail",
        title: "Como você fará Login",
        subtitle:
          "Insira um endereço de e-mail para fazer login na sua Conta Housien",
        emailPlaceholder: "E-mail",
      },

      createPassword: {
        pageTitle: "Criar Senha",
        title: "Crie uma Senha",
        subtitle:
          "Crie uma senha forte com uma combinação de letras, números e símbolos",
        passwordPlaceholder: "Senha",
        confirmPasswordPlaceholder: "Confirmar Senha",
      },

      insertUsernameCode: {
        pageTitle: "Verificar E-mail",
        title: "Verifique seu E-mail",
        subtitle:
          "Parabéns por criar sua Conta Housien. Agora digite o código de verificação enviado para o e-mail inserido",
        codePlaceholder: "Inserir código",
      },

      congratulations: {
        pageTitle: "Bem-vindo!",
        title: "Conta criada com sucesso",
        subtitle: "Conecte-se agora para aproveitar todos os nossos serviços.",
        bodyText:
          "Parabéns! Sua Conta Housien está pronta.",
        loginLink: "Conectar-se",
      },

      onboarding: {
        pageTitle: "Completar Registro",
        title: "Bem-vindo, {{name}}",
        subtitle: "Um último passo para começar.",
        body: "Ao continuar, você permite que a K4D envie atualizações importantes sobre sua conta, alertas de segurança e comunicações do serviço.",
      }
    },

    popUp: {
      titlePrefix: "Ops...",
      titleError: "Algo deu errado",
      titleNetworkError: "Sem conexão",
      bodyTextError: "Não foi possível completar sua solicitação. Tente novamente.",
      bodyTextNetworkError: "Verifique sua conexão com a internet e tente novamente.",
      bodyText: "Caso persistir entre em contato conosco informando o código de erro",
      contactSubtitle: "Contato",
      moreDetailsLink: "Mais Detalhes",
      detailsToggle: "Detalhes técnicos",
      dismissButton: "Tentar novamente",
    },

    countries: {
      AF: "Afeganistão",
      AL: "Albânia",
      DZ: "Argélia",
      AD: "Andorra",
      AO: "Angola",
      AG: "Antígua e Barbuda",
      AR: "Argentina",
      AM: "Armênia",
      AU: "Austrália",
      AT: "Áustria",
      AZ: "Azerbaijão",
      BS: "Bahamas",
      BH: "Bahrein",
      BD: "Bangladesh",
      BB: "Barbados",
      BY: "Bielorrússia",
      BE: "Bélgica",
      BZ: "Belize",
      BJ: "Benin",
      BT: "Butão",
      BO: "Bolívia",
      BA: "Bósnia e Herzegovina",
      BW: "Botsuana",
      BR: "Brasil",
      BN: "Brunei",
      BG: "Bulgária",
      BF: "Burkina Faso",
      BI: "Burundi",
      CV: "Cabo Verde",
      KH: "Camboja",
      CM: "Camarões",
      CA: "Canadá",
      CF: "República Centro-Africana",
      TD: "Chade",
      CL: "Chile",
      CN: "China",
      CO: "Colômbia",
      KM: "Comores",
      CG: "Congo",
      CD: "República Democrática do Congo",
      CR: "Costa Rica",
      CI: "Costa do Marfim",
      HR: "Croácia",
      CU: "Cuba",
      CY: "Chipre",
      CZ: "República Tcheca",
      DK: "Dinamarca",
      DJ: "Djibuti",
      DM: "Dominica",
      DO: "República Dominicana",
      EC: "Equador",
      EG: "Egito",
      SV: "El Salvador",
      GQ: "Guiné Equatorial",
      ER: "Eritreia",
      EE: "Estônia",
      SZ: "Eswatini",
      ET: "Etiópia",
      FJ: "Fiji",
      FI: "Finlândia",
      FR: "França",
      GA: "Gabão",
      GM: "Gâmbia",
      GE: "Geórgia",
      DE: "Alemanha",
      GH: "Gana",
      GR: "Grécia",
      GD: "Granada",
      GT: "Guatemala",
      GN: "Guiné",
      GW: "Guiné-Bissau",
      GY: "Guiana",
      HT: "Haiti",
      HN: "Honduras",
      HU: "Hungria",
      IS: "Islândia",
      IN: "Índia",
      ID: "Indonésia",
      IR: "Irã",
      IQ: "Iraque",
      IE: "Irlanda",
      IL: "Israel",
      IT: "Itália",
      JM: "Jamaica",
      JP: "Japão",
      JO: "Jordânia",
      KZ: "Cazaquistão",
      KE: "Quênia",
      KI: "Kiribati",
      KP: "Coreia do Norte",
      KR: "Coreia do Sul",
      KW: "Kuwait",
      KG: "Quirguistão",
      LA: "Laos",
      LV: "Letônia",
      LB: "Líbano",
      LS: "Lesoto",
      LR: "Libéria",
      LY: "Líbia",
      LI: "Liechtenstein",
      LT: "Lituânia",
      LU: "Luxemburgo",
      MG: "Madagascar",
      MW: "Malawi",
      MY: "Malásia",
      MV: "Maldivas",
      ML: "Mali",
      MT: "Malta",
      MH: "Ilhas Marshall",
      MR: "Mauritânia",
      MU: "Maurício",
      MX: "México",
      FM: "Micronésia",
      MD: "Moldávia",
      MC: "Mônaco",
      MN: "Mongólia",
      ME: "Montenegro",
      MA: "Marrocos",
      MZ: "Moçambique",
      MM: "Myanmar",
      NA: "Namíbia",
      NR: "Nauru",
      NP: "Nepal",
      NL: "Países Baixos",
      NZ: "Nova Zelândia",
      NI: "Nicarágua",
      NE: "Níger",
      NG: "Nigéria",
      MK: "Macedônia do Norte",
      NO: "Noruega",
      OM: "Omã",
      PK: "Paquistão",
      PW: "Palau",
      PA: "Panamá",
      PG: "Papua Nova Guiné",
      PY: "Paraguai",
      PE: "Peru",
      PH: "Filipinas",
      PL: "Polônia",
      PT: "Portugal",
      QA: "Catar",
      RO: "Romênia",
      RU: "Rússia",
      RW: "Ruanda",
      KN: "São Cristóvão e Nevis",
      LC: "Santa Lúcia",
      VC: "São Vicente e Granadinas",
      WS: "Samoa",
      SM: "San Marino",
      ST: "São Tomé e Príncipe",
      SA: "Arábia Saudita",
      SN: "Senegal",
      RS: "Sérvia",
      SC: "Seicheles",
      SL: "Serra Leoa",
      SG: "Singapura",
      SK: "Eslováquia",
      SI: "Eslovênia",
      SB: "Ilhas Salomão",
      SO: "Somália",
      ZA: "África do Sul",
      SS: "Sudão do Sul",
      ES: "Espanha",
      LK: "Sri Lanka",
      SD: "Sudão",
      SR: "Suriname",
      SE: "Suécia",
      CH: "Suíça",
      SY: "Síria",
      TW: "Taiwan",
      TJ: "Tajiquistão",
      TZ: "Tanzânia",
      TH: "Tailândia",
      TL: "Timor-Leste",
      TG: "Togo",
      TO: "Tonga",
      TT: "Trinidad e Tobago",
      TN: "Tunísia",
      TR: "Turquia",
      TM: "Turcomenistão",
      TV: "Tuvalu",
      UG: "Uganda",
      UA: "Ucrânia",
      AE: "Emirados Árabes Unidos",
      GB: "Reino Unido",
      US: "Estados Unidos",
      UY: "Uruguai",
      UZ: "Uzbequistão",
      VU: "Vanuatu",
      VA: "Vaticano",
      VE: "Venezuela",
      VN: "Vietnã",
      YE: "Iêmen",
      ZM: "Zâmbia",
      ZW: "Zimbábue"
    },

    warningTexts: {

      oAuth2: {
        usernameFormatError: "Coloque o E-mail corretamente.",
        usernameInvalidException: "Usuário não registrado.",
        tokenExpired: "Sessão expirada. Por favor, faça login novamente.",
        passwordFormatError: "Senha deve conter 8 caracteres.",
        passwordInvalidException: "Senha Incorreta. Tente Novamente.",
      },

      signup: {
        confirmPassword: "As senhas não são iguais. Tente novamente.",
        date: "Insira uma data válida.",
        name: "Insira seu {{id}} corretamente.",
        password: {
          beginning: "A senha deve conter pelo menos",
          length: "8 caracteres,",
          number: "um número,",
          uppercase: "uma letra maiúscula,",
          lowercase: "uma letra minúscula,",
          specialCharacter: "um caractere especial,",
        },
        select: "Insira um {{id}} válido.",
        username: "Insira um email válido.",
        usernameAlreadyExistsError: "Usuário já registrado.",
        code: "Código inválido. Tente Novamente.",
        acceptTerms: "Você deve aceitar os termos de serviço.",
      },

      date: {
        year: "Insira um ano válido.",
        month: "Insira um mês válido.",
        day: "Insira um dia válido.",
        age: "Idade abaixo do necessário.",
      },

    },
  },
};

export default ptBrTranslations;
